export const EMAIL_FORM_VIEW = {
  OTP_VIEW: 'OTP_VIEW',
  EMAIL_VIEW: 'EMAIL_VIEW',
  ORG_VIEW: 'ORG_VIEW',
};
